import { render, staticRenderFns } from "./PatternShapes.vue?vue&type=template&id=1c0d1bd6"
import script from "./PatternShapes.vue?vue&type=script&lang=js"
export * from "./PatternShapes.vue?vue&type=script&lang=js"
import style0 from "./PatternShapes.vue?vue&type=style&index=0&id=1c0d1bd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports